import { InterventionGroup } from "../../../../../../../store/onboarding/cases/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../../store";

const useInterventionGroupReorder = () => {
    const existingGroupOrderConfig =
        useSelector(
          (s: ApplicationState) =>
            s.auth?.userInfo?.profile.additional_info?.group_order
        ) || {};
    
    const groupReorderSorting = (interventionGroups: InterventionGroup[], selectedCaseId: number) => {
        if (
        !existingGroupOrderConfig ||
        !interventionGroups ||
        !interventionGroups.length
        ) {
        return interventionGroups;
        }

        /**
         * Build ordering map from API structure
         */
        const orderingMap: Record<number, number> =
        {};

        const processPageGroups = (
        pageGroups: any = {}
        ) => {
        Object.values(pageGroups).forEach(
            (groupIds: any) => {
            if (Array.isArray(groupIds)) {
                groupIds.forEach(
                (
                    groupId: number,
                    index: number
                ) => {
                    orderingMap[groupId] = index;
                }
                );
            }
            }
        );
        };
        if(window.location.pathname.includes('groups/reading')) {
        processPageGroups(
            existingGroupOrderConfig.reading_groups_page
        );
        } else if(window.location.pathname.includes('groups/behavior')) {
        processPageGroups(
            existingGroupOrderConfig.behavior_groups_page
        );
        }

        /**
         * Sort groups based on saved ordering
         */
        const sortedGroups = [
        ...interventionGroups,
        ].sort((a, b) => {
        const indexA =
            orderingMap[a.id] ?? Number.MAX_SAFE_INTEGER;

        const indexB =
            orderingMap[b.id] ?? Number.MAX_SAFE_INTEGER;

        return indexA - indexB;
        });

        return sortedGroups;
    };

    return {
        groupReorderSorting
    };

};
export default useInterventionGroupReorder;